export const messages = {
    "shared-link.footer.link.install": "Wypróbuj program {brandName} bezpłatnie",
    "shared-link.footer.link.mobile": "{brandName} na urządzenie mobilne",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Chronione dane",
    "shared-link.password-dialog-box.message": "Podaj hasło, aby uzyskać dostęp do udostępnionych danych",
    "shared-link.password-dialog-box.hint.password": "Hasło",
    "shared-link.password-dialog-box.message.invalid-password": "Hasło jest niepoprawne",
    "shared-link.form.button.open": "Otwórz",
    "shared-link.page-not-found.title": "Nie znaleziono strony",
    "shared-link.page-not-found.message.main": "Nie znaleziono szukanej strony.",
    "shared-link.page-not-found.message.description": "Być może łącze jest nieaktualne lub wpisano niepoprawny adres.",
    "shared-link.page-not-found.message.error": "Kod błędu: 404",
    "shared-link.restore-file.label.size": "Rozmiar",
    "shared-link.restore-file.button.restore": "Pobierz",
    "shared-link.links-table.column.name": "Nazwa",
    "shared-link.links-table.column.size": "Rozmiar",
    "shared-link.links-table.action.restore": "Pobierz",
    "shared-link.links-table.action.restore-all": "Pobierz wszystko",
    "shared-link.side-bar.selected.title:plural": "Wybrane pozycje: {count} | Wybrane pozycje: {count} | Wybrane pozycje: {count} | Wybrane pozycje: {count} | Wybrane pozycje: {count}",
    "shared-link.links-table.label.size": "Rozmiar",
    "shared-link.links-table.message.empty-folder": "Folder jest pusty"
};
